// extracted by mini-css-extract-plugin
export default {"persiePlayer":"VideoViewer_persiePlayer__hnpzc","persieVideo":"VideoViewer_persieVideo__kWXGs","videoFill":"VideoViewer_videoFill__04sho","videoFit":"VideoViewer_videoFit__8CQyO"};